import { render, staticRenderFns } from "./jobRoleDetailsModal.vue?vue&type=template&id=07b2777b&"
import script from "./jobRoleDetailsModal.vue?vue&type=script&lang=js&"
export * from "./jobRoleDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports